document.addEventListener('DOMContentLoaded', function () {
  const numberForm = document.getElementById('mmTrackingForm');
  const orderContainer = document.querySelector('.main-order-container');
  const numberInput = document.getElementById('number-input');
  const activityContainer = document.getElementById('activityContainer');
  const orderStatusBar = document.querySelector('.order-progress-bar');

  numberForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const enteredNumber = numberInput.value;
    getOrderDetails(enteredNumber);
  })
  function getOrderDetails(orderID) {
  const requestData = {
    orderId: orderID
  };
  
  // Make the API request
  fetch('https://levisshiprocket.marmeto.com/get/order-tacking', {
    method: 'POST',
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success == true) {
        orderContainer.classList.remove('tw-hidden');
        const shipmentData = data[0].tracking_data.shipment_status;
        if (shipmentData == '6') {
          orderStatusBar.style.width = '25%';
          document.querySelector('width-0').classList.add('current');
        } else if (shipmentData == '18') {
          orderStatusBar.style.width = '50%';
          document.querySelector('width-0').classList.add('current');
          document.querySelector('width-25').classList.add('current');
        } else if (shipmentData == '17') {
          orderStatusBar.style.width = '75%';
          document.querySelector('width-0').classList.add('current');
          document.querySelector('width-25').classList.add('current');
          document.querySelector('width-50').classList.add('current');
        } else if (shipmentData == '7') {
          orderStatusBar.style.width = '100%';
          document.querySelector('width-0').classList.add('current');
          document.querySelector('width-25').classList.add('current');
          document.querySelector('width-50').classList.add('current');
          document.querySelector('width-100').classList.add('current');
        } else {
          orderStatusBar.style.width = '50%';
          document.querySelector('width-0').classList.add('current');
          document.querySelector('width-25').classList.add('current');
        }
  
        document.querySelector('.sr-courier-name').innerHTML = data[0].tracking_data.shipment_track[0].courier_name;
        document.querySelector('.sr-tracking-id').innerHTML = data[0].tracking_data.shipment_track[0].id;
        document.querySelector('.sr-order-id').innerHTML = data[0].tracking_data.shipment_track[0].order_id;
  
        // Access the last 'status' and 'date' from 'shipment_track_activities'
        const shipmentTrackActivities = data[0].tracking_data.shipment_track_activities;
        if (shipmentTrackActivities.length > 0) {
          // Create a container div for the activity entries
          const activityEntriesContainer = document.createElement('div');
          activityEntriesContainer.classList.add('activity-entries-container');
          shipmentTrackActivities.forEach((activity) => {
            // Create a div for each activity entry
            const activityDiv = document.createElement('div');
            activityDiv.classList.add('activity-entry');
  
            const location = document.createElement('p');
            location.textContent = `Location: ${activity.location}`;
  
            const date = document.createElement('p');
            date.textContent = `Date: ${activity.date}`;
  
            const activityText = document.createElement('p');
            activityText.textContent = `Activity: ${activity.activity}`;
  
            activityDiv.appendChild(location);
            activityDiv.appendChild(date);
            activityDiv.appendChild(activityText);
  
            // Add the activity entry to the container
            activityEntriesContainer.appendChild(activityDiv);
          });
          // Append the container to the activityContainer
          activityContainer.appendChild(activityEntriesContainer);
          const lastActivity = shipmentTrackActivities[0];
          const lastStatus = lastActivity.location;
          const lastDate = lastActivity.date;
          document.querySelector('.sr-last-update').innerHTML = `${lastStatus} on ${lastDate}`;
          document.querySelector('.sr-order-placed').innerHTML = lastDate;
        } else {
          document.querySelector('.sr-last-update').innerHTML = 'No updates found';
        }
      } else {
        resultDisplay.textContent = "No success message found";
      }
    })
  }
  if(window.location.href.includes("/pages/track-order?orderID=")){
    const orderID = window.location.href.split("orderID=")[1];
    if(orderID) {
      numberInput.value = orderID;
      getOrderDetails(orderID)
    }
  }
})
